// add a button to toggle all open/closed
( function() {
	// get every "first" collapsible element
	var firstCollapsibles = document.querySelectorAll('[data-component="collapsible"]:first-of-type');
	const EXPAND_TEXT = 'Expand All';
	const COLLAPSE_TEXT = 'Collapse All';
	if(firstCollapsibles.length > 0){
		firstCollapsibles.forEach((detail) => {
			// get the siblings of each first collapsible element
			var subsequentDetailsEls = document.querySelectorAll(`#${detail.id} ~ [data-component="collapsible"]`)
			// array with first collapsible plus subsequent
			var completeSet = [detail].concat(Array.from(subsequentDetailsEls));
			var completeSetIdArr = completeSet.map((el) => {
				return el.id
			})
			var completeSetIds = completeSetIdArr.join(',');
			// make a button 
			var btnWrap = document.createElement('div');
			btnWrap.classList.add('toggle-collapsibles')
			btnWrap.innerHTML = `<button class="button outline" type="button" aria-expanded="false" aria-controls="${completeSetIds}">${EXPAND_TEXT}</button>`;
			detail.parentNode.insertBefore(btnWrap, detail);
			var btn = btnWrap.querySelector('button');
			// on button click, open or close all related details
			btn.addEventListener('click', (e) => {
				var isExpanded = e.target.getAttribute('aria-expanded') === 'true';
				completeSet.forEach((detail) => {
					isExpanded ? detail.removeAttribute('open') : detail.setAttribute('open', true);
				})
				btn.setAttribute('aria-expanded', !isExpanded)
				isExpanded ? btn.innerHTML = EXPAND_TEXT : btn.innerHTML = COLLAPSE_TEXT
			})
			
		})
	}
})();


( function() {
	function transformDisclosureComponents(tabSets) {
		var form = window.getComputedStyle(tabSets[0], ':before').content.replace(/\"/g, '');
		if(form === 'tabs'){
			// JS to show only a single details content (tab) at a time
			tabSets.forEach(function(tabSet){
				tabSet.classList.add('tabs');
				tabSet.children[0].setAttribute('open', true);
				tabSet.addEventListener('click', closeOpenTabs);
				tabSet.setAttribute('data-num-tabs', tabSet.children.length)
			});			
		} else {
			tabSets.forEach(function(tabSet){
				tabSet.classList.remove('tabs');
				tabSet.removeEventListener('click', closeOpenTabs);
			})
		}
	}
	// only allow one open tab at a time
	function closeOpenTabs(event) {
			const tabs = event.currentTarget;
			const target = event.target;
			// TODO is this right?
			if (!target.matches("summary") && !target.closest("summary")) {
				return;
			}

			const parentDetails = target.closest('details');

			if (parentDetails.open) {
				event.preventDefault();
				return;
			}

			tabs.querySelectorAll('details').forEach(function(details) {
				if (details !== parentDetails && details.open) {
					details.open = false;
				}
			});
	}

	function wrapAll(arr, wrapper) {
		if (arr && arr.length) {
			arr[0].parentNode.insertBefore(wrapper, arr[0]);
			for (var i in arr) {
				wrapper.appendChild(arr[i]);
			}
		}
		return wrapper;
	}
	
	// get first tab
	var firstTabs = document.querySelectorAll('[data-component="tab"]:first-of-type');
	if(firstTabs.length > 0){
		firstTabs.forEach((detail) => {
			// get the siblings of each first tab element
			var subsequentTabs = document.querySelectorAll(`#${detail.id} ~ [data-component="tab"]`)
			// array with first collapsible plus subsequent
			var completeSet = [detail].concat(Array.from(subsequentTabs));

			var wrapper = wrapAll(completeSet, document.createElement('div'));
			wrapper.classList.add('collapsibles-to-tabs');
			
		})
		// set of all tab components
		var tabSets = document.querySelectorAll('.collapsibles-to-tabs');
		transformDisclosureComponents(tabSets);
			var resizeTimer;
			window.addEventListener('resize', function(e) {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function() {
					transformDisclosureComponents(tabSets)  ;          
				}, 250);
			});
	}


})();